import { Reducer } from '@reduxjs/toolkit'
import { ContactExportAction } from './contactExport.actions'
import {
  OPEN_DIALOG,
  CLOSE_DIALOG,
  GET_SAVED_EXPORTS_REQUESTED,
  GET_SAVED_EXPORTS_SUCCESS,
  GET_SAVED_EXPORTS_FAILURE,
  GET_LOCATIONS_REQUESTED,
  GET_LOCATIONS_SUCCESS,
  GET_LOCATIONS_FAILURE,
  GET_SEARCHES_REQUESTED,
  GET_SEARCHES_SUCCESS,
  GET_SEARCHES_FAILURE,
  SAVE_CONTACT_EXPORT_REQUESTED,
  SAVE_CONTACT_EXPORT_SUCCESS,
  SAVE_CONTACT_EXPORT_FAILURE,
  DELETE_SAVED_EXPORT_REQUESTED,
  DELETE_SAVED_EXPORT_SUCCESS,
  DELETE_SAVED_EXPORT_FAILURE,
} from './contactExport.constants'

interface ContactExportState {
  open: boolean,
  loading: boolean,
  savedExports: {
    data: $TSFIXME[],
    error: $TSFIXME,
    loading: boolean,
  },
  locations: {
    data: $TSFIXME[],
    error: $TSFIXME,
    loading: boolean,
  },
  searches: {
    data: $TSFIXME[],
    error: $TSFIXME,
    loading: boolean,
  },
}

const initialState: ContactExportState = {
  open: false,
  loading: false,
  savedExports: {
    data: [],
    error: null,
    loading: false,
  },
  locations: {
    data: [],
    error: null,
    loading: false,
  },
  searches: {
    data: [],
    error: null,
    loading: false,
  },
}

const reducer: Reducer<ContactExportState, ContactExportAction> = (state = initialState, action) => {
  switch (action.type) {
    case OPEN_DIALOG:
      return { ...initialState, open: true }
    case CLOSE_DIALOG:
      return initialState

    case GET_SAVED_EXPORTS_REQUESTED:
      return {
        ...state,
        savedExports: {
          data: state.savedExports.data,
          error: state.savedExports.error,
          loading: true,
        },
      }
    case GET_SAVED_EXPORTS_SUCCESS:
      return {
        ...state,
        savedExports: { data: action.savedExports, error: null, loading: false },
      }
    case GET_SAVED_EXPORTS_FAILURE:
      return {
        ...state,
        savedExports: {
          // eslint-disable-next-line @typescript-eslint/consistent-type-assertions -- TODO: remove type assertion
          data: {} as $TSFIXME, // TODO: every other use of savedExports.data refers to it as an array; this should probably be changed to []
          // eslint-disable-next-line @typescript-eslint/consistent-type-assertions -- TODO: remove type assertion
          error: (action.error as $TSFIXME).message,
          loading: false,
        },
      }

    case GET_LOCATIONS_REQUESTED:
      return {
        ...state,
        locations: {
          data: state.locations.data,
          error: state.locations.error,
          loading: true,
        },
      }
    case GET_LOCATIONS_SUCCESS:
      return {
        ...state,
        locations: { data: action.locations, error: null, loading: false },
      }
    case GET_LOCATIONS_FAILURE:
      return {
        ...state,
        locations: {
          // eslint-disable-next-line @typescript-eslint/consistent-type-assertions -- TODO: remove type assertion
          data: {} as $TSFIXME, // TODO: every other use of locations.data refers to it as an array; this should probably be changed to []
          // eslint-disable-next-line @typescript-eslint/consistent-type-assertions -- TODO: remove type assertion
          error: (action.error as $TSFIXME).message,
          loading: false,
        },
      }

    case GET_SEARCHES_REQUESTED:
      return {
        ...state,
        searches: {
          data: state.searches.data,
          error: state.searches.error,
          loading: true,
        },
      }
    case GET_SEARCHES_SUCCESS:
      return {
        ...state,
        searches: { data: action.searches, error: null, loading: false },
      }
    case GET_SEARCHES_FAILURE:
      return {
        ...state,
        searches: {
          // eslint-disable-next-line @typescript-eslint/consistent-type-assertions -- TODO: remove type assertion
          data: (action as $TSFIXME).searches, // TODO: GET_SEARCHES_FAILURE doesn't set `searches` on its action; this can probably be removed
          // eslint-disable-next-line @typescript-eslint/consistent-type-assertions -- TODO: remove type assertion
          error: (action.error as $TSFIXME).message,
          loading: false,
        },
      }

    case SAVE_CONTACT_EXPORT_REQUESTED:
      return {
        ...state,
        loading: true,
      }
    case SAVE_CONTACT_EXPORT_SUCCESS:
      return {
        ...state,
        loading: false,
        savedExports: {
          data: [...state.savedExports.data, action.data],
          error: null,
          loading: false,
        },
      }
    case SAVE_CONTACT_EXPORT_FAILURE:
      return {
        ...state,
        loading: false,
        savedExports: {
          data: state.savedExports.data,
          // eslint-disable-next-line @typescript-eslint/consistent-type-assertions -- TODO: remove type assertion
          error: (action.error as $TSFIXME).message,
          loading: false,
        },
      }

    case DELETE_SAVED_EXPORT_REQUESTED:
      return {
        ...state,
        loading: true,
      }
    case DELETE_SAVED_EXPORT_SUCCESS:
      return {
        ...state,
        loading: false,
        savedExports: {
          data: state.savedExports.data.filter(e => e.id !== action.id),
          error: null,
          loading: false,
        },
      }
    case DELETE_SAVED_EXPORT_FAILURE:
      return {
        ...state,
        loading: false,
        savedExports: {
          data: state.savedExports.data,
          // eslint-disable-next-line @typescript-eslint/consistent-type-assertions -- TODO: remove type assertion
          error: (action.error as $TSFIXME).message,
          loading: false,
        },
      }

    default:
      return state
  }
}

export default reducer
